import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { SubscriptionProductDTO } from 'crono-fe-common/types/DTO/SubscriptionPlansDTO';
import { StripeEnvironment } from 'crono-fe-common/types/otherSettings';

//Own is passed when we want the BE to identify which are the products correct based on the stripe env of the subscription
export default function useGetSubscriptionProducts(
  stripeEnvironment: StripeEnvironment | 'own',
) {
  const queryString =
    stripeEnvironment !== 'own'
      ? new URLSearchParams({
          stripeEnvironment,
        }).toString()
      : '';
  const request: Request = {
    url: ENDPOINTS.subscription.products.main + '?' + queryString,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.subscription.products.main, stripeEnvironment],
    queryFn: () => client(request),
    staleTime: 24 * 60 * 60 * 1000,
  };

  const { data, ...rest } = useQuery<
    Response<SubscriptionProductDTO[]>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}
